import React, { useContext } from 'react';
import { Box } from '@mui/material';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import matmanHelperButton from 'assets/images/matman-helper-button.png';
import matmanSelectedHelperButton from 'assets/images/matman-selected-helper-button.png';
import ImageButton from './ImageButton';
import { InstructionButtonContext } from 'state/providers/InstructionsButtonProvider';

const tA11y = (key: string) => translate('a11y', key);

type Props = {
  styles?: React.CSSProperties;
  components?: any;
};

const MatmanActivityButton: React.FC<Props> = ({ styles, components }) => {
  const [{ playInstructionFlag }, { playInstructions }] = useContext(InstructionButtonContext);
  return (
    <Box style={styles}>
      <ImageButton
        hoveredImgSrc={matmanSelectedHelperButton}
        notHoveredImgSrc={matmanHelperButton}
        imgAlt={tA11y('alt.matmanHelperButton')}
        onClick={() => !playInstructionFlag && playInstructions()}
        style={styles}
      />
      {components && <div>{components}</div>}
    </Box>
  );
};

export default MatmanActivityButton;
